"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const rxjs_1 = require("rxjs");
/**
 * @deprecated Don't use oo modelling anymore. Use simple types or `shared-modelling` instead.
 */
class List {
    constructor() {
        this.items = [];
        this._changes$ = new rxjs_1.Subject();
        this.changes$ = this._changes$.asObservable();
    }
    emitChange() {
        this._changes$.next();
    }
    /**
     * Adds an item to the list.
     *
     * @param item The item to add.
     */
    add(item) {
        if (item == null)
            throw new Error('List.add: item is null or undefined');
        if (this.has(item))
            throw new Error('List.add: item is already listed');
        this.items.push(item);
        this._changes$.next();
    }
    addAfter(item, predecessor) {
        if (item == null)
            throw new Error('List.addAfter: item is null or undefined');
        if (this.has(item))
            throw new Error('List.addAfter: item is already listed');
        if (predecessor == null)
            throw new Error('List.addAfter: predecessor is null or undefined');
        if (!this.has(predecessor))
            throw new Error('List.addAfter: predecessor is not listed');
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], predecessor)) {
                this.items.splice(i + 1, 0, item);
                this._changes$.next();
                return;
            }
        }
    }
    /**
     * Replaces one item by a different item.
     *
     * @param oldItem The old list item.
     * @parem newItem The new list item.
     */
    replace(oldItem, newItem) {
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], oldItem)) {
                this.items[i] = newItem;
                this._changes$.next();
                return;
            }
        }
    }
    /**
     * Replaces one item by another.
     *
     * @param item The item to update.
     */
    update(item) {
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], item)) {
                this.items[i] = item;
                this._changes$.next();
                return;
            }
        }
    }
    /**
     * Removes all occurences of an item from the list.
     *
     * @param itemToRemove The item to remove
     */
    remove(itemToRemove) {
        const oldLength = this.items.length;
        this.items = this.items.filter((item) => !this.itemsAreSameEntity(item, itemToRemove));
        if (this.items.length < oldLength)
            this._changes$.next();
    }
    /**
     * Removes all item from the list.
     */
    removeAll() {
        this.items = [];
        this._changes$.next();
    }
    /**
     * Removes all items which meets the condition
     *
     * @param conditionFunc The condition func will be called with each item. If it returns true for
     * an item the item will be removed
     */
    removeIf(conditionFunc) {
        if (!conditionFunc || !(conditionFunc instanceof Function))
            return;
        const prevCount = this.items.length;
        for (let i = 0; i < prevCount; i++) {
            if (conditionFunc(this.items[i]))
                this.items.splice(i, 1);
        }
        if (prevCount !== this.items.length)
            this._changes$.next();
    }
    /**
     * Checks if the list contains the item
     *
     * @param itemToCheck The item to check
     * @returns Wether the list contains the item or not.
     */
    has(itemToCheck) {
        return this.items.some((item) => this.itemsAreSameEntity(item, itemToCheck));
    }
    /**
     * Retrieves the item with the same entity
     */
    getEntity(itemToCheck) {
        return this.items.find((item) => this.itemsAreSameEntity(item, itemToCheck));
    }
    /**
     * Retrieves a new array with all items
     *
     * @returns All items.
     * @deprecated Use "toArray()" instead
     */
    getAll() {
        return this.toArray();
    }
    /**
     * Retrieves an item from the list supporting several search options. By default it will search
     * for the id.
     *
     * @param searchForValue The value to search for
     * @param property The property use to compare the value
     * @param options
     * @param options.ignoreCase Performs a string-based search ignoring the case
     * @param options.searchFunc Performs a search bases on a custom function
     * @returns The first found item.
     */
    get(searchForValue, property, options) {
        const key = property || 'id';
        const ignoreCase = !!(options && options.ignoreCase);
        let searchFunc = options ? options.searchFunc : undefined;
        if (typeof searchFunc !== 'function') {
            if (ignoreCase) {
                // eslint-disable-next-line
                searchFunc = (valueA, valueB) => {
                    return String(valueA).toUpperCase() === String(valueB).toUpperCase();
                };
            }
            else {
                // eslint-disable-next-line
                searchFunc = (valueA, valueB) => {
                    return valueA === valueB;
                };
            }
        }
        return this.items.find((item) => searchFunc(item[key], searchForValue));
    }
    /**
     * Retrieves all items which have equal values.
     *
     * @param itemToGet The item to search for.
     * @param comparator The custom comparison function.
     * @returns All equal items.
     */
    getHavingEqualValues(itemToGet, comparator) {
        const isEqual = comparator || this.itemsHaveEqualValues.bind(this);
        return this.items.filter((item) => isEqual(item, itemToGet));
    }
    /**
     * Retrieves the item count
     *
     * @returns The item count
     */
    count(itemToCount) {
        if (itemToCount) {
            return this.items.filter((item) => this.itemsAreSameEntity(item, itemToCount)).length;
        }
        return this.items.length;
    }
    /**
     * Returns true if the list is empty, false otherwise
     */
    isEmpty() {
        return this.items.length === 0;
    }
    /**
     * Retrieves a new instance of an array with all items
     *
     * @returns The array with all items
     */
    toArray() {
        return this.items.slice(0);
    }
    /**
     * Replaces the internal list of all items by given items.
     *
     * @param items The array with all new items
     * @returns this.
     */
    fromArray(items) {
        this.items = items.slice(0);
        return this;
    }
    /**
     * Retrieves wether to given items have the same entityId
     *
     * @returns The result
     */
    itemsAreSameEntity(item1, item2) {
        return item1.is(item2); // eslint-disable-line
    }
    /**
     * Retrieves wether to given items have equal values
     *
     * @returns The result
     */
    itemsHaveEqualValues(item1, item2) {
        return item1.hasEqualValues(item2); // eslint-disable-line
    }
    filter(callbackfn) {
        // we needed to pass "this: K" or else we aren't able to call this.clone properly
        // preserve items
        const items = this.items;
        this.items = [];
        // this operation will clone all the items and then while filtering it they will be just replaced,
        // so this is just waste of time, should actually be new K()
        const filteredList = this.clone();
        // set items back
        this.items = items;
        if (!callbackfn || !(callbackfn instanceof Function))
            return filteredList;
        filteredList.items = this.items.filter(callbackfn);
        return filteredList;
    }
    at(index) {
        return this.items.at(index);
    }
}
exports.List = List;
//# sourceMappingURL=List.js.map